/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

/**
 * The form status
 */
export const SUBMITTED_STATUS = "Submitted";
export const SAVED_STATUS = "Saved";
export const DENIED_STATUS = "Denied";
export const ACCEPTED_STATUS = "Accepted";
export const INVITED_STATUS = "Invited";
export const UNDER_REVIEW_STATUS = "Under Review";
export const NOMINATION_AUTO_DECLINED_STATUS = "Nomination Auto Declined";
